
import { loginService } from './loginService';
import { passwordService } from './passwordService';
import { verificationService } from './verificationService';

/**
 * Auth email service facade that brings together all auth-related email services
 */
export const authEmailService = {
  // Login-related operations
  sendMagicLink: loginService.sendMagicLink,
  sendNewLoginEmail: loginService.sendNewLoginEmail,
  
  // Password-related operations
  triggerPasswordReset: passwordService.triggerPasswordReset,
  sendPasswordChangedEmail: passwordService.sendPasswordChangedEmail,
  
  // Verification-related operations
  sendVerificationEmail: verificationService.sendVerificationEmail
};
